import React, { useEffect, useState } from "react";
import UserBox from "./user_box";

const WallsLikeUsers = ({ wallId }) => {
  const [users, setUsers] = useState([]);

  useEffect(
    () => {
      $.ajax({
        url: "/api/walls/walls_like_users",
        type: "GET",
        cache: false,
        data: {
          wall_id: wallId,
        },
        contentType: false,
      })
        .done((data) => {
          setUsers(data.users);
        })
        .fail(() => {});
    },
    [wallId]
  );

  return (
    <div>
      <div className="container col-md-8 col-lg-6 p-4">
        <h2 className="h2 h2--extend -member2">
          いいねしたユーザー<span className="text-fz-14px" />
        </h2>
      </div>
      <hr className="m-0" />
      <div className="container col-md-8 col-lg-6">
        <ul className="mb-3_5 list-unstyled">
          {users.map((user) => <UserBox key={user.id} user={user} />)}
        </ul>
      </div>
    </div>
  );
};

export default WallsLikeUsers;
